<div class="breakdown-analysis" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="title-box">
    <h2>{{ t('modals.fuelConsumptionBreakdown.title') }}</h2>
    <button type="button" (click)="closeModal()">
      <img src="assets/images-fuel/closeModalBtnIcon.svg" alt="close-icon" />
    </button>
  </div>

  <div class="modal-body">
    <div class="modal-row">
      <div class="modal-left">
        <div class="card bottom-padding">
          <h3>{{ t('modals.fuelConsumptionBreakdown.tableTitle') }}</h3>
          <!-- <app-common-table [modalType]="'fuel-consumption'"></app-common-table> -->
          <div class="main-table fuel-consumption">
            <table class="table">
              <thead>
                <tr>
                  <th class="factor">{{ t('table.factor') }}</th>
                  <th class="last-month">
                    {{ t('table.lastMonth') }}<button class="filter-button">
                      <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                    </button>
                  </th>
                  <th class="this-month">
                    {{ t('table.thisMonth') }}<button class="filter-button">
                      <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                    </button>
                  </th>
                  <th class="change">
                    {{ t('table.change') }}<button class="filter-button">
                      <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                    </button>
                  </th>
                  <th class="inpact">{{ t('table.impactOnConsumption') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.totalVehicles') }}</p>
                  </td>
                  <td class="last-month">
                    <p>50</p>
                  </td>
                  <td class="this-month">
                    <p>55</p>
                  </td>
                  <td class="change">
                    <p>+10%</p>
                  </td>
                  <td class="inpact">
                    <span class="chip increase"><img src="assets/images-fuel/increaseChipIcon.svg" alt="icon" />{{ t('table.increasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.totalFuelUsed') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.kilometres', { value: '10 250 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.kilometres', { value: '275 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>-10%</p>
                  </td>
                  <td class="inpact">
                    <span class="chip decrease"><img src="assets/images-fuel/decreasedIcon.svg" alt="icon" />{{ t('table.decreasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.averageSpeed') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.kmPerHour', { value: '80' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.kmPerHour', { value: '80' }) }}</p>
                  </td>
                  <td class="change">
                    <p>0%</p>
                  </td>
                  <td class="inpact">
                    <span class="chip increase"><img src="assets/images-fuel/increaseChipIcon.svg" alt="icon" />{{ t('table.increasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.idleTimeHours') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.hour', { value: '1' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.hour', { value: '3' }) }}</p>
                  </td>
                  <td class="change">
                    <p>{{ t('values.hoursIncrease', { value: '2' }) }}</p>
                  </td>
                  <td class="inpact">
                    <span class="chip increase"><img src="assets/images-fuel/increaseChipIcon.svg" alt="icon" />{{ t('table.increasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.harshAcceleration') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.per100Km', { value: '10' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.per100Km', { value: '15' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+50%</p>
                  </td>
                  <td class="inpact">
                    <span class="chip increase"><img src="assets/images-fuel/increaseChipIcon.svg" alt="icon" />{{ t('table.increasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.engineConditionScore') }}</p>
                  </td>
                  <td class="last-month">
                    <p>85</p>
                  </td>
                  <td class="this-month">
                    <p>78</p>
                  </td>
                  <td class="change">
                    <p>+10%</p>
                  </td>
                  <td class="inpact">
                    <span class="chip increase"><img src="assets/images-fuel/increaseChipIcon.svg" alt="icon" />{{ t('table.increasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.totalDistance') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.kilometres', { value: '250 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.kilometres', { value: '275 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>+10%</p>
                  </td>
                  <td class="inpact">
                    <span class="chip decrease"><img src="assets/images-fuel/decreasedIcon.svg" alt="icon" />{{ t('table.decreasedOnConsumption') }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.fuelConsumptionBreakdown.driverEfficiencyScore') }}</p>
                  </td>
                  <td class="last-month">85%</td>
                  <td class="this-month">78%</td>
                  <td class="change">-8.24%</td>
                  <td class="inpact">
                    <span class="chip decrease"><img src="assets/images-fuel/decreasedIcon.svg" alt="icon" />{{ t('table.decreasedOnConsumption') }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-right">
        <div class="card grap-card dicrease mb-1 bottom-padding">
          <div class="card-body p-0">
            <div class="grap-up d-flex align-items-center justify-content-between">
              <div class="graph-text">
                <h4>{{ t('widgets.fuelConsumption') }}</h4>
                <p>
                  {{ t('values.litresPerKm', { value: '40' }) }} <strong>+3.12%</strong>
                  <i><img src="./assets/images-fuel/downArrowOrnageIcon.svg" alt="down-icon" /></i>
                </p>
              </div>
              <div class="button-wrapper">
                <div class="common-drop-down no-filter dropdown">
                  <button type="button" id="dropdown-menubutton" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="grap-buttontn" />
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdown-menubutton">
                    <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                    </li>
                  </ul>
                </div>
                <button class="full-button-grap" (click)="fullChartClick()">
                  <img src="assets/images-fuel/grapBtnIcon.svg" alt="grap-button" />
                </button>
              </div>
            </div>
            <div class="grap-down line-chart">
              @defer (on timer(100ms)) {
              <app-multi-line-chart [data]="lineChartData" [chartConfig]="lineConfigs" [yConfig]="{suffix: 'ℓ'}"
                [margin]="{ top: 30, right: 0, bottom: 0, left: 28, height: 145 }" />
              }

            </div>
          </div>
        </div>
        <div class="card grap-card increase bottom-padding">
          <div class="card-body p-0">
            <div class="grap-up d-flex align-items-center justify-content-between">
              <div class="graph-text ">
                <h4>{{ t('widgets.highestFuelConsumption') }}</h4>
                <p>
                  75% <strong>+19.29%</strong>
                  <i><img src="./assets/images-fuel/upgreen-icon.svg" alt="up-icon" /></i>
                </p>
              </div>
            </div>
            <div class="grap-down piechart-main">
              <app-pie-chart />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>